import { ResultProps } from "./searchResult";

export enum SearchIndexEnum {
  sendGrid = "sghc",
  twilio = "twlo",
}

export enum ScoreConfidence {
  VERY_HIGH = "VERY_HIGH",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export enum RelevanceValue {
  relevant = "relevant",
  notRelevant = "notRelevant",
}

export enum ResultType {
  ANSWER = "ANSWER",
  DOCUMENT = "DOCUMENT",
  QUESTION_ANSWER = "QUESTION_ANSWER",
}

export interface Highlight {
  beginOffset: number;
  endOffset: number;
  topAnswer?: boolean;
}

export interface Excerpt {
  key?: "AnswerText";
  highlights: Highlight[];
  text: string;
}

interface SuggestionValue {
  text: Excerpt;
}

export interface Suggestion {
  id: string;
  value: SuggestionValue;
}

export interface BaseResult {
  id: string;
  scoreConfidence: ScoreConfidence;
  type: ResultType;
}

export interface SearchResultResponse extends BaseResult {
  documentTitle: Excerpt;
  documentUri: string;
  resultExcerpts: Excerpt[];
}

export interface SearchResult extends BaseResult {
  body: string;
  isRecommended: boolean;
  queryId: string;
  title: string;
  url: string;
}

export interface FormatSearchResultsReturn {
  results: ResultProps[];
  hasRecommendedResult: boolean;
}
